/** 配置可自动录单的保险公司 */
export const automatic = [9801, 9804, 9805, 9808, 9814, 9817, 9819, 9820, 9821, 9827, 9829, 9830, 9832, 9835, 9840, 9847, 9848, 9850, 9864, 9869, 9873]

/** 配置首页不可见的黑名单 */
export const blackList = ['baite', 'dhxf']

export const newLoginNavPartnerIds = ['10000', '22435']
export const additionalPermissions = ['10000', 'zhicheng', 'zcsd', 'jinglue', 'zhongtong', 'hbyc', 'huixin', 'luzhishipin', 'gxytbx', 'huajun']
/** 配置可自定义域名和logo的商户信息 */
export const customDomainAndLogo = [{
  subdomain: 'jblsx',
  name: '数字金融保险服务平台',
  logo: '',
  domain: 'youbaolian.top',
  path: '/page/login'
}, {
  subdomain: 'zslkj',
  name: '销合云录单平台',
  subName: '销合云',
  logo: '',
  domain: 'youbaolian.top',
  path: '/zsl/login'
}, {
  subdomain: 'zsl',
  name: '销合云录单平台',
  subName: '销合云',
  logo: '',
  domain: 'youbaolian.top',
  path: '/zsl/login'
}]
export const rewardConfigArr = {
  'P-YP000239': 31,
  'P-YP-PA-DQS': 21.5,
  'P-YP-PA-CX-A-1-3': 25.5,
  'P-YP-PA-CX-A-4-5': 25.5,
  'P-YP-PA-CX-B-1-3': 25.5,
  'P-YP-PA-CX-B-4-5': 25.5,
  'P-YP-PA-CX-C-1-3': 25.5,
  'P-YP-PA-CX-C-4-5': 25.5,
  'P-YP-PA-CX-D-1-5': 25.5,
  'P-YP000393': 21.5,
  'P-YP000398': 21.5,
  'P-YP000399': 13,
  'P-YP000557': 20.5,
  'P-YP000417': 24.5,
  'P-YP000592': 35.5,
  'P-YP000593': 30,
  'P-YP000594': 30,
  'P-YP000595': 30,
  'P-YP000596': 30,
  'P-YP000597': 30,
  'P-YP000598': 30,
  'P-YP000591': 56.5,
  'PDC00189': 18.5
}
export default {
  automatic,
  blackList,
  newLoginNavPartnerIds,
  additionalPermissions,
  customDomainAndLogo
}



// WEBPACK FOOTER //
// ./src/config/automatic.js